import {
  SET_SUBMITTING_FOR_ADMIN_VIRTUAL_EVENT_DETAIL,
  SET_VIRTUAL_ENTRY_BOWLER_FOR_ADMIN_VIRTUAL_EVENT_DETAIL,
  SET_VIRTUAL_ENTRY_TEAM_FOR_ADMIN_VIRTUAL_EVENT_DETAIL,
  SET_DETAILS_FOR_ADMIN_VIRTUAL_EVENT_DETAIL,
  SET_AVAILABLE_BOWLERS_FOR_ADMIN_VIRTUAL_EVENT_DETAIL,
  SET_AVAILABLE_TEAMS_FOR_ADMIN_VIRTUAL_EVENT_DETAIL,
  SET_VIRTUAL_ENTRIES_FOR_ADMIN_VIRTUAL_EVENT_DETAIL,
  CALCULATE_SELECTED_BALANCE_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL,
  SET_VIRTUAL_ENTRY_SELECTED_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL,
  DISPLAY_PAYMENT_MODAL_FOR_ADMIN_VIRTUAL_ENTRY_DETAIL,
  SET_SELECTED_BALANCE_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL,
  SET_REFUND_TYPE_FOR_ADMIN_VIRTUAL_ENTRY_DETAIL,
  DISPLAY_CAPTAIN_VIRTUAL_ENTRY_CHANGE_MODAL_FOR_ADMIN,
  SET_IS_NEW_CAPTAIN_VIRTUAL_ENTRIES_MODAL_FOR_ADMIN,
  SET_VIRTUAL_EVENT_DETAIL_CREDIT_PURCHASE_TRANSACTIONS
} from './constants';

export const displayVirtualEventSubmitting = visible => ({
  type: SET_SUBMITTING_FOR_ADMIN_VIRTUAL_EVENT_DETAIL,
  payload: visible
});

export const setBowlerForVirtualEntry = (virtualEntryId, bowlerId) => ({
  type: SET_VIRTUAL_ENTRY_BOWLER_FOR_ADMIN_VIRTUAL_EVENT_DETAIL,
  payload: {virtualEntryId, bowlerId}
});

export const setTeamForVirtualEntry = (virtualEntryId, entryId) => ({
  type: SET_VIRTUAL_ENTRY_TEAM_FOR_ADMIN_VIRTUAL_EVENT_DETAIL,
  payload: {virtualEntryId, entryId}
});

export const setVirtualEventDetailsInState = virtualEventDetails => ({
  type: SET_DETAILS_FOR_ADMIN_VIRTUAL_EVENT_DETAIL,
  payload: virtualEventDetails
});

export const setAvailableBowlersInState = bowlers => ({
  type: SET_AVAILABLE_BOWLERS_FOR_ADMIN_VIRTUAL_EVENT_DETAIL,
  payload: bowlers
});

export const setAvailableTeamsInState = teams => ({
  type: SET_AVAILABLE_TEAMS_FOR_ADMIN_VIRTUAL_EVENT_DETAIL,
  payload: teams
});

export const setVirtualEntriesInState = virtualEntries => ({
  type: SET_VIRTUAL_ENTRIES_FOR_ADMIN_VIRTUAL_EVENT_DETAIL,
  payload: virtualEntries
});

export const calculateSelectedBalance = () => ({
  type: CALCULATE_SELECTED_BALANCE_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL
});

export const setVirtualEntrySelected = (virtualEntryId) => ({
  type: SET_VIRTUAL_ENTRY_SELECTED_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL,
  payload: virtualEntryId
});

export const displayVirtualEntryDetailPaymentModal = (showModal, paymentModalType) => ({
  type: DISPLAY_PAYMENT_MODAL_FOR_ADMIN_VIRTUAL_ENTRY_DETAIL,
  payload: {showModal, paymentModalType}
});

export const setSelectedBalance = (balance) => ({
  type: SET_SELECTED_BALANCE_FOR_ADMIN_CAPTAIN_VIRTUAL_ENTRY_DETAIL,
  payload: balance
});

export const setRefundTypeForAdminVirtualEntryDetail = (refundType) => ({
  type: SET_REFUND_TYPE_FOR_ADMIN_VIRTUAL_ENTRY_DETAIL,
  payload: refundType
});

export const displayCaptainVirtualEntryChangeModal = () => ({
  type: DISPLAY_CAPTAIN_VIRTUAL_ENTRY_CHANGE_MODAL_FOR_ADMIN, 
  payload: true
});

export const setIsNewCaptainOnSearch = isNew => ({
  type: SET_IS_NEW_CAPTAIN_VIRTUAL_ENTRIES_MODAL_FOR_ADMIN,
  payload: isNew
});

export const hideVirtualEntryDetailChangeCaptainModal = () => ({
  type: DISPLAY_CAPTAIN_VIRTUAL_ENTRY_CHANGE_MODAL_FOR_ADMIN,
  payload: false
});

export const setCreditPurchaseTransactions = creditPurchaseTransactions => ({
  type: SET_VIRTUAL_EVENT_DETAIL_CREDIT_PURCHASE_TRANSACTIONS,
  payload: creditPurchaseTransactions
});


// WEBPACK FOOTER //
// ./src/features/admin/virtualEventDetail/actionTypes.js